import { render, staticRenderFns } from "./CardBodyLink.vue?vue&type=template&id=06e0834b"
import script from "./CardBodyLink.vue?vue&type=script&lang=ts"
export * from "./CardBodyLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e0834b')) {
      api.createRecord('06e0834b', component.options)
    } else {
      api.reload('06e0834b', component.options)
    }
    module.hot.accept("./CardBodyLink.vue?vue&type=template&id=06e0834b", function () {
      api.rerender('06e0834b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CardBodyLink.vue"
export default component.exports